<template>
  <pt-detection-package-new class="pt-detection-package-new__page"></pt-detection-package-new>
</template>

<script>
import PtDetectionPackageNew from 'cps/gene-product/pt-detection-package-new/withData'
export default {
  name: 'pt-detection-package-new__view',
  components: {
    'pt-detection-package-new': PtDetectionPackageNew
  }
}
</script>
